<template>
  <PageContent class="batch-edit-wrapper">
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2
      type="w6"
      title="Personal Information"
      @nextClick="saveForms()"
      mode="edit"
    >
      <template v-slot:title-solt>
      </template>
      <template v-slot:content-solt>
        <MerchantForm
          v-model="merchantForm"
          ref="merchantForm"
        />
      </template>
    </PanelV2>

  </PageContent>
</template>

<script>
  import API from "@/api";
  import MerchantForm from "@/pc/forms/BDOMerchantFormLite.val";

  export default {
    name: 'EditPersonalInfo2',
    pRouter: 'App',
    components: {
      MerchantForm,
    },
    data() {
      return {
        merchantForm: {
          email: '', 
          firstName: '', 
          middleName: '', 
          lastName: '', 
          suffix: '', 
          mobile: '',
        },
      }
    },
    created() {
      API.getBdoProcessData({
        token: this.getCookieItem('token'),
        pageNo: '999',
      }).then((res) => {
        console.log(res)
        if (res.success) {
          const { personalInfo } = res.obj;
          Object.assign(this.merchantForm, personalInfo);
        }
      })
    },
    mounted() {
      const email = document.getElementsByTagName('input')[6]
      email.readOnly = 'readOnly'
      email.style.cssText = "cursor: not-allowed;background-color: #F5F7FA;border-color: #E4E7ED;color: #C0C4CC;"
    },
    methods: {

      saveForms() {
        const {
          merchantForm,
        } = this.$refs

        Promise.all([
            merchantForm.$refs.appForm
          ].map(form => {

            return new Promise((reslove) => {
              form.validate(valid => {
                reslove(valid);
              })
            })
          })).then((res) => {
            const [res1] = res;
            
            if (res1) {
              API.editBdoProcess({
                token: this.getCookieItem('token'),
                pageNo: `0`,
                personalInfo: this.merchantForm,
              }).then(res => {
                if (res.success) {
                  window.history.go(-1);
                }
              })
            }
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .panel-v2.content-area {
    margin: 16px 0;
  }
</style>
